import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Breadecrumb from '../../Globle/Breadecrumb'
import Blog from '../MainBlog/Blog'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadecrumb title='Blog' />
            <Blog />
            <Footer1 />
        </>
    )
}

export default Main
